/**
 * A wrapper around an API function to handle different
 * states e.g. loading, error and response received.
 */
export default {
  data() {
    return {
      loading: false,
      error: null,
      response: null
    };
  },
  methods: {
    async request(apiFunction, ...params) {
      this.loading = true;
      this.error = null;
      try {
        this.response = await apiFunction(...params);
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
      }
    }
  }
};
